import { Translation } from '@ps/web-shared-components';
import React from 'react';

import MBWayLogo from '../../../../../../assets/logos/mbway.svg';

import { TXTWCL_Please_go_to_the_MB_Way_app_to_ELL } from './MBWayRedirect.messages.json';
import { logo } from './MBWayRedirect.scss';

const MBWayRedirect = () => (
  <>
    <Translation tagName="p" {...TXTWCL_Please_go_to_the_MB_Way_app_to_ELL} />
    <MBWayLogo className={logo} />
  </>
);

export default MBWayRedirect;
